import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M13.28 5.23v8.27a1.22 1.22 0 0 1-.69 1.14 1.12 1.12 0 0 1-.47.11 1.28 1.28 0 0 1-.85-.33c-.21-.17-2-1.44-3.27-2.37-1.3.93-3 2.2-3.25 2.37a1.33 1.33 0 0 1-.86.33 1.12 1.12 0 0 1-.47-.11 1.22 1.22 0 0 1-.69-1.14V5.23a3.63 3.63 0 0 1 3.94-4h2.67a3.6 3.6 0 0 1 3.94 4Z';
const draw24px =
  'M14,2.16H10c-3.51,0-5.52,2-5.52,5.55v12.4a1.44,1.44,0,0,0,.81,1.37,1.24,1.24,0,0,0,.56.13,1.61,1.61,0,0,0,1-.41c.33-.28,3.09-2.27,5.12-3.72,2,1.44,4.8,3.44,5.13,3.72a1.61,1.61,0,0,0,1,.41,1.39,1.39,0,0,0,.56-.13,1.44,1.44,0,0,0,.81-1.37V7.71C19.53,4.18,17.51,2.16,14,2.16Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BookmarkFilledIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'bookmarkFilled')) as IconWithRender;

BookmarkFilledIcon.displayName = 'BookmarkFilledIcon';
BookmarkFilledIcon.propTypes = Icon.propTypes;
BookmarkFilledIcon.renderIcon = (props) => <BookmarkFilledIcon {...props} />;
export default BookmarkFilledIcon;
